import { render, staticRenderFns } from "./AsyncBlogCarousel.vue?vue&type=template&id=53c86249&scoped=true"
import script from "./AsyncBlogCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AsyncBlogCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AsyncBlogCarousel.vue?vue&type=style&index=0&id=53c86249&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c86249",
  null
  
)

export default component.exports